//
export default function createTempId(seed) {
  return `[TEMP] SEED:${seed}/${Date.now()}/${Math.random()}`;
}
